"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_minutes__sms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "minutes-sms-hi"), /*#__PURE__*/React.createElement("g", {
    id: "15379667-8159-4c50-b61f-cac67416ca71",
    "data-name": "minutes-sms-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3182ac03-53c9-4c2a-80c5-a244d681bcd6",
    "data-name": "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2987905e-032d-4c52-9b25-32ea6b045bf9",
    "data-name": "Calls_Contacts_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d80d6ea6-03ae-476f-8501-83fc86ea8f4b",
    "data-name": "PayG_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ed4e6206-0c65-444c-bd93-5d2956670d0c",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "da5d2152-c60d-4516-92ea-7b58c3d3dde8",
    "data-name": "My_Vodafone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dd668224-682b-4e55-834d-45860e1331ef",
    "data-name": "Settings_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d8e42895-6cb2-459a-aae1-3adc9edd72f0",
    "data-name": "User_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bcad0c12-5b7c-4a56-9510-fbcf35ea7066",
    "data-name": "Video_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f56cfafd-54fd-4b7d-b426-a78e1ed67a89",
    "data-name": "Tutorials_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9bf2e6d2-060c-4bea-a007-bea38559be4c",
    "data-name": "Community_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9dbf568e-279b-4ddc-bc8e-b86f43ff775a",
    "data-name": "Entertainment_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b7cc4712-533d-4dd8-ba09-91cf00aa6068",
    "data-name": "Insurance_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1698113f-b981-4821-b53b-437e406c8e4e",
    "data-name": "Photos_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b91c2108-324a-44f8-ab5b-5e4e45a9c724",
    "data-name": "Pie_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c70e9eeb-80ae-4900-bafa-2dab46f864ba",
    "data-name": "Shopping_trolley_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "09485ee0-b009-474a-9f24-9f6116849e50",
    "data-name": "Business_phone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5a4cc0f6-8a1d-4ed2-9317-da800379377c",
    "data-name": "Bundles_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5a78587c-e09d-465d-9a4f-3712920a8ad9",
    "data-name": "Customer_care_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9b1315dc-af6d-4efd-8dfc-2faa2d869159",
    "data-name": "Minutes_sms_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "f1de11bd-89a1-4c83-8c03-830a12da78a7",
    "data-name": "Bounding Box",
    x: 0.25,
    y: 0.25,
    width: 191.5,
    height: 191.5,
    transform: "translate(192 0) rotate(90)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,16a8,8,0,0,0-8,8V64a8,8,0,0,0,8,8h44.77a4,4,0,0,1,2.74,1.09L160,88.64V72h8a8,8,0,0,0,8-8V24a8,8,0,0,0-8-8Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.77,70H96a8,8,0,0,1-8-8v2a8,8,0,0,0,8,8h44.77a4,4,0,0,1,2.74,1.09L160,88.64v-2L143.51,71.09A4,4,0,0,0,140.77,70Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,70h-8v2h8a8,8,0,0,0,8-8V62A8,8,0,0,1,168,70Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,38H106a2,2,0,0,1,0-4h52a2,2,0,0,1,0,4Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,54H106a2,2,0,0,1,0-4h52a2,2,0,0,1,0,4Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "86aed2d5-3830-415a-87b9-398dd1bc48cd",
    "data-name": "<Pfad>",
    d: "M106.83,127.48l12.2-9.2c3.22-1.65,6.54-2.05,8.54-.82,3,1.86,28.44,18.87,30.59,20.38s3.13,5.78.12,9.94-16.79,20.58-22.55,20.37-29.79-.91-74.62-46S16,53.27,15.89,47.56s16.72-19.07,21-22,8.56-1.77,10,.3C48.6,28.26,65.16,53.59,67,56.49c1.24,2,.75,5.27-1,8.43s-8.86,15.23-8.86,15.23,4.86,8.37,21.41,25C86.42,113.25,106.83,127.48,106.83,127.48Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.29,145.77c-3,4.16-16.79,20.58-22.55,20.37s-29.79-.91-74.62-46C19.36,78.11,16.26,54.61,15.93,47a3.34,3.34,0,0,0,0,.58C16,53.27,16.3,77,61.12,122.12s68.84,45.79,74.62,46,19.55-16.21,22.55-20.37a8.85,8.85,0,0,0,1.81-6.37A9.62,9.62,0,0,1,158.29,145.77Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.83,127.48h0l-.3-.19Z",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.55,127.28l-.15-.11h0Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.26,124.9l-3.41,2.57c5.29,3.32,25.93,17.07,44,29.17.94-1,1.85-2,2.69-3C136.55,142.25,117.16,129.33,110.26,124.9Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.14,78.15s.19.33.61,1c1.76-3,6.84-11.6,8.24-14.2a11.21,11.21,0,0,0,1.6-6.64A13.41,13.41,0,0,1,66,62.93C64.29,66.09,57.14,78.15,57.14,78.15Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.44,76.26c-5.16-8-19.84-30.48-29.6-45.22-1,.83-2,1.71-3.06,2.63,10.63,16.07,26.9,41,30.38,46.45Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.85,154.64c-16.72-11.2-35.64-23.81-42.56-28.26l-1.44,1.08c5.29,3.32,25.93,17.07,44,29.17.94-1,1.85-2,2.69-3l-1.11-.74C151.92,153.47,151.39,154.05,150.85,154.64Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.62,32.94l-.84.73c10.63,16.07,26.9,41,30.38,46.45l2.28-3.86-.62-1-1.66,2.82C53.78,72.79,38.24,49,27.62,32.94Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }))))))))))))))))))))));
}

var _default = ic_minutes__sms;
exports.default = _default;